export default __webpack_public_path__ + "static/media/newsimplan-icon02-en.ebe4d59c.png";